import { useState, useEffect, useCallback, createContext, useContext } from "react";
import { Dumbbell, X, Footprints, Heart, Zap, Bell } from "lucide-react";

const FitModalCtx = createContext({ handleOpenFitness: () => {}, isOpen: false });
export const useFitModal = () => useContext(FitModalCtx);

export const FitModalProvider = ({ children }) => {
  const [show, setShow] = useState(false);
  const [visible, setVisible] = useState(false);

  // Single entry point for all Fitness access.
  // Future: swap modal logic for navigation to VORA Fit environment.
  const handleOpenFitness = useCallback(() => {
    setShow(true);
    requestAnimationFrame(() => setVisible(true));
  }, []);

  const close = useCallback(() => {
    setVisible(false);
    setTimeout(() => setShow(false), 260);
  }, []);

  useEffect(() => {
    if (!show) return;
    const onKey = (e) => { if (e.key === "Escape") close(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [show, close]);

  return (
    <FitModalCtx.Provider value={{ handleOpenFitness, isOpen: show }}>
      <div className={`vf-scene${visible ? " vf-scene--away" : ""}`}>
        {children}
      </div>
      {show && (
        <div className={`vf-overlay${visible ? " vf-overlay--in" : ""}`} onClick={close} data-testid="vf-overlay">
          <div className={`vf-modal${visible ? " vf-modal--in" : ""}`} onClick={(e) => e.stopPropagation()} data-testid="vf-modal">
            <button className="vf-close" onClick={close} data-testid="vf-close"><X size={16} /></button>

            <div className="vf-hero-icon"><Dumbbell size={24} /></div>
            <h2 className="vf-title">VORA Fit</h2>
            <p className="vf-sub">Your performance system is coming</p>
            <p className="vf-desc">Track workouts, activity, and recovery</p>

            {/* Mini preview UI */}
            <div className="vf-preview" data-testid="vf-preview">
              <div className="vf-preview-ring" style={{ "--vf-rc": "#EA580C" }}><Footprints size={14} /><span>Steps</span></div>
              <div className="vf-preview-ring" style={{ "--vf-rc": "#3B82F6" }}><Dumbbell size={14} /><span>Workout</span></div>
              <div className="vf-preview-ring" style={{ "--vf-rc": "#22C55E" }}><Heart size={14} /><span>Recovery</span></div>
              <div className="vf-preview-ring" style={{ "--vf-rc": "#F59E0B" }}><Zap size={14} /><span>Energy</span></div>
            </div>

            <div className="vf-actions">
              <button className="vf-cta" onClick={close} data-testid="vf-cta">Back to Nutrition</button>
              <button className="vf-secondary" onClick={close} data-testid="vf-notify"><Bell size={14} /> Get notified</button>
            </div>
          </div>
        </div>
      )}
    </FitModalCtx.Provider>
  );
};
